import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import useAuth from './context/auth';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuth();
  return (
    <Route
      {...rest}
      render={() =>
        user ? (
          <Component {...rest} />
        ) : (
            <Redirect
              to={{ pathname: '/login', state: { referer: rest.location } }}
            />
          )
      }
    />
  );
};

PrivateRoute.defaultProps = {
  location: {},
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object,
};

export default PrivateRoute;
